import { fetchProductList } from '#/api/crmMgmt/product/fetchList';

function buildProductSelectOption(product) {
  if (!product?.id) {
    return null;
  }
  return {
    value: product.id,
    label: [product.productNo, product.name].filter(Boolean).join(' - ')
      || String(product.id),
    productNo: product.productNo,
    name: product.name,
    salesUnitName: product.salesUnitName,
  };
}

export function mapProductRowsToSelectOptions(rows = []) {
  return rows.map((row) => buildProductSelectOption(row)).filter(Boolean);
}

/** 編輯時若產品已停用／不在 ACTIVE select，併入選項以免空白。 */
export function mergeProductSelectOption(options = [], product) {
  const option = buildProductSelectOption(product);
  if (!option) {
    return options;
  }
  if (options.some((item) => item.value === option.value)) {
    return options;
  }
  return [...options, option];
}

/**
 * ACTIVE 產品 select options（客戶訂單 Create 等）。
 * 可帶 `customerId` 篩該客戶產品。
 * 使用 lookupQueryKey('productSelect', { customerId })。
 *
 * @param {{ customerId?: string } | undefined} options
 */
export async function fetchProductSelectOptions(options = {}) {
  const { customerId } = options;
  const filters = { status: 'ACTIVE' };
  if (customerId) {
    filters.customerId = customerId;
  }

  const { data } = await fetchProductList({
    page: 1,
    pageSize: 200,
    keyword: '',
    sort: [],
    filters,
  });

  return mapProductRowsToSelectOptions(data ?? []);
}
